import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleEnterPress } from '../helpers/util';
import { cancelTransfer, hideDialler, holdCall, initiateTransfer, muteCall, showDialler, unholdCall, unmuteCall, } from '../reducers/calls';
import { setVolume } from '../reducers/client';
import styles from '../styles/callControls.scss';
import Slider from './Slider';
import { DialpadIcon, HoldIcon, MuteIcon, TransferIcon, VolumeIcon, } from './icons';
const CallControls = () => {
    const dispatch = useDispatch();
    const volume = useSelector((state) => state.client.volume);
    const call = useSelector((state) => state.calls.find((c) => c.active === true));
    const { id, onHold, muted, diallerVisible, transferInitiated } = call || {};
    const [showVolume, setShowVolume] = useState(false);
    const volumeToggleId = 'volume-toggle-control';
    const holdCallClick = (id) => {
        dispatch(holdCall(id));
    };
    const unholdCallClick = (id) => {
        dispatch(unholdCall(id));
    };
    const muteCallClick = (id) => {
        dispatch(muteCall(id));
    };
    const unmuteCallClick = (id) => {
        dispatch(unmuteCall(id));
    };
    const transferClick = (id) => {
        dispatch(initiateTransfer({ id }));
    };
    const transferCancelClick = (id) => {
        dispatch(cancelTransfer({ id }));
    };
    const changeVolume = (volume) => {
        dispatch(setVolume(volume));
    };
    const showDiallerClick = (id) => {
        dispatch(showDialler({ id }));
    };
    const hideDiallerClick = (id) => {
        dispatch(hideDialler({ id }));
    };
    // FIXME is this correct?
    if (!id) {
        return null;
    }
    const toggleMute = () => {
        return muted ? unmuteCallClick(id) : muteCallClick(id);
    };
    const toggleShowVolume = () => {
        setShowVolume(!showVolume);
    };
    const toggleHold = () => {
        return onHold ? unholdCallClick(id) : holdCallClick(id);
    };
    const toggleDialer = () => {
        return diallerVisible ? hideDiallerClick(id) : showDiallerClick(id);
    };
    const toggleTransfer = () => {
        return transferInitiated ? transferCancelClick(id) : transferClick(id);
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement("span", { className: muted ? styles.control_active : styles.control, onClick: toggleMute, onKeyDown: handleEnterPress(toggleMute), role: 'button', tabIndex: 0 },
            React.createElement(MuteIcon, { className: styles.icon })),
        React.createElement("span", { className: styles.volume_control },
            React.createElement("div", { className: styles.volume_clickable, id: volumeToggleId, onClick: toggleShowVolume, onKeyDown: handleEnterPress(toggleShowVolume), role: 'button', tabIndex: 0 }),
            React.createElement("div", { className: styles.volume_container },
                React.createElement(VolumeIcon, { className: styles.icon }),
                React.createElement(Slider, { visible: showVolume, defaultValue: volume, onChange: (e) => {
                        const { value } = e.target;
                        // For some reason the value returned by the
                        // slider is a string, so cast it to a float
                        const floatValue = parseFloat(value);
                        changeVolume(floatValue);
                    }, onOutsideClick: () => {
                        setShowVolume(false);
                    }, ignoreId: volumeToggleId })),
            React.createElement("div", { className: styles.progress_border, style: { width: `${volume * 100}%` } })),
        React.createElement("span", { className: onHold ? styles.control_active : styles.control, onClick: toggleHold, onKeyDown: handleEnterPress(toggleHold), role: 'button', tabIndex: 0 },
            React.createElement(HoldIcon, { className: styles.icon })),
        React.createElement("span", { className: diallerVisible ? styles.control_active : styles.control, onClick: toggleDialer, onKeyDown: handleEnterPress(toggleDialer), role: 'button', tabIndex: 0 },
            React.createElement(DialpadIcon, { className: styles.icon })),
        React.createElement("span", { className: transferInitiated ? styles.control_active : styles.control, onClick: toggleTransfer, onKeyDown: handleEnterPress(toggleTransfer), role: 'button', tabIndex: 0 },
            React.createElement(TransferIcon, { className: styles.icon }))));
};
export default CallControls;
